import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import { Link } from "react-router-dom";

const STEPS = [
  { n: "01", t: "Enquiry & Consultation", d: "You share your brief, budget and inspiration. We arrange a site visit or design consultation." },
  { n: "02", t: "Concept Design", d: "We produce concept elevations, a curated material palette and a first-pass investment guide." },
  { n: "03", t: "Design Development", d: "We refine the design, integrate AV, lighting and fireplace, coordinate with your architect or builder." },
  { n: "04", t: "Specification & Investment", d: "A detailed proposal — every material, every element, every dollar transparently accounted for." },
  { n: "05", t: "Procurement & Production", d: "Stone slabs, veneers, joinery and hardware are sourced and produced." },
  { n: "06", t: "Installation & Handover", d: "Our team installs on site, commissions the AV and hands over a resolved wall — beautifully built." },
];

export default function ProcessPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="process-page">
      <PublicNav/>
      <section className="pt-32 pb-12 px-6 lg:px-12 max-w-6xl mx-auto">
        <div className="overline">The Process</div>
        <h1 className="font-serif font-light mt-4" style={{ fontSize: "clamp(44px, 6vw, 68px)", lineHeight: 1.05 }}>How we work.</h1>
        <p className="text-muted-foreground mt-4 max-w-2xl text-lg">A structured process from first enquiry to installed wall — designed to remove uncertainty and keep every decision considered.</p>
      </section>
      <section className="max-w-6xl mx-auto px-6 lg:px-12 pb-24">
        <div className="grid md:grid-cols-2 gap-px bg-border border border-border">
          {STEPS.map((s) => (
            <div key={s.n} className="bg-card p-10">
              <div className="overline text-[10px]" style={{ color: "#A68A64" }}>Step {s.n}</div>
              <div className="font-serif text-3xl mt-3">{s.t}</div>
              <p className="text-muted-foreground mt-3 text-sm leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-16 text-center">
          <Link to="/enquiry" data-testid="btn-process-enquire" className="btn-accent inline-flex" style={{ padding: "16px 28px" }}>Begin your project</Link>
        </div>
      </section>
      <PublicFooter/>
    </div>
  );
}
